import script from "./AddVariantProductCollection.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddVariantProductCollection.vue?vue&type=script&lang=ts&setup=true"

import "./AddVariantProductCollection.vue?vue&type=style&index=0&id=7b98012d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b98012d"]])

export default __exports__